import React from "react";
import { getAutoAddData } from "./getAutoAddData";
import { createApi } from "../../../utils/createApi";
import { AxiosError } from "axios";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";

// Function to check site status and poll until refresh is completed
const checkSiteStatusAndPoll = (
  setCamerasList: any,
  setCamerasObject: any,
  setFetchingAutoAddData: any,
  checkboxesChecked: any,
  setCheckboxesChecked: any,
  setClientProducts: any,
  setImmixSite: any,
  setSureviewSite: any,
  setProductsArray: any,
  setSelectedProducts: any,
  setAutoAddError: any,
  setAutoAddSiteInfo: any,
  navigate: any
) => {
  const AxiosUI = createApi(``);
  const startTime = Date.now();
  const maxWaitTime = 90000; // 1 minute and 30 seconds in milliseconds

  const pollSiteStatus = () => {
    // Check if we've exceeded the maximum wait time
    if (Date.now() - startTime > maxWaitTime) {
      // Timeout reached, proceed with getAutoAddData
      getAutoAddData(
        setCamerasList,
        setCamerasObject,
        setFetchingAutoAddData,
        checkboxesChecked,
        setCheckboxesChecked,
        setClientProducts,
        setImmixSite,
        setSureviewSite,
        setProductsArray,
        setAutoAddSiteInfo,
        navigate
      );
      return;
    }

    AxiosUI.get(`site_status/?customer=${localStorage.siteId}`)
      .then((response) => {
        const { results } = response.data;

        if (results && results.length > 0) {
          const siteStatus = results[0];
          const lastRefreshStarted = siteStatus.last_refresh_started;
          const lastRefreshCompleted = siteStatus.last_refresh_completed;

          if (
            lastRefreshCompleted &&
            Number(lastRefreshStarted) < Number(lastRefreshCompleted)
          ) {
            // Refresh is completed, proceed with getAutoAddData
            getAutoAddData(
              setCamerasList,
              setCamerasObject,
              setFetchingAutoAddData,
              checkboxesChecked,
              setCheckboxesChecked,
              setClientProducts,
              setImmixSite,
              setSureviewSite,
              setProductsArray,
              setAutoAddSiteInfo,
              navigate
            );
          } else {
            // Refresh not completed yet, continue polling every 3 seconds
            setTimeout(pollSiteStatus, 3000);
          }
        } else {
          // No results, continue polling
          setTimeout(pollSiteStatus, 3000);
        }
      })
      .catch((error: AxiosError) => {
        // On error, continue polling
        getAutoAddData(
          setCamerasList,
          setCamerasObject,
          setFetchingAutoAddData,
          checkboxesChecked,
          setCheckboxesChecked,
          setClientProducts,
          setImmixSite,
          setSureviewSite,
          setProductsArray,
          setAutoAddSiteInfo,
          navigate
        );
      });
  };

  // Start polling
  pollSiteStatus();
};

export const handleRefreshCameraList = (
  setCamerasList: any,
  setCamerasObject: any,
  setFetchingAutoAddData: any,
  checkboxesChecked: any,
  setCheckboxesChecked: any,
  setClientProducts: any,
  setImmixSite: any,
  setSureviewSite: any,
  setProductsArray: any,
  setSelectedProducts: any,
  setAutoAddError: any,
  setAutoAddSiteInfo: any,
  navigate: any
) => {
  setCamerasList({});
  setCamerasObject([]);
  setFetchingAutoAddData(true);
  setClientProducts([]);
  setSelectedProducts([]);
  setCheckboxesChecked({});
  setImmixSite(false);
  setSureviewSite(false);
  setAutoAddError(false);
  setProductsArray([]);

  const AxiosUI = createApi(``);

  const retryFunction = () => {
    handleRefreshCameraList(
      setCamerasList,
      setCamerasObject,
      setFetchingAutoAddData,
      checkboxesChecked,
      setCheckboxesChecked,
      setClientProducts,
      setImmixSite,
      setSureviewSite,
      setProductsArray,
      setSelectedProducts,
      setAutoAddError,
      setAutoAddSiteInfo,
      navigate
    );
  };

  AxiosUI.post(
    `customer/${localStorage.siteId}/action/refresh_camera_list/`
  ).then(
    () => {
      // Start polling for site status until refresh is completed
      checkSiteStatusAndPoll(
        setCamerasList,
        setCamerasObject,
        setFetchingAutoAddData,
        checkboxesChecked,
        setCheckboxesChecked,
        setClientProducts,
        setImmixSite,
        setSureviewSite,
        setProductsArray,
        setSelectedProducts,
        setAutoAddError,
        setAutoAddSiteInfo,
        navigate
      );
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        getAutoAddData(
          setCamerasList,
          setCamerasObject,
          setFetchingAutoAddData,
          checkboxesChecked,
          setCheckboxesChecked,
          setClientProducts,
          setImmixSite,
          setSureviewSite,
          setProductsArray,
          setAutoAddSiteInfo,
          navigate
        );
      });
    }
  );
};
